module.exports = __webpack_public_path__ + "static/index/img/home-food.73b90a78.jpg";